import { render, staticRenderFns } from "./_retiradaDinheiro.vue?vue&type=template&id=077706c2&scoped=true&"
import script from "./_retiradaDinheiro.vue?vue&type=script&lang=js&"
export * from "./_retiradaDinheiro.vue?vue&type=script&lang=js&"
import style0 from "./_retiradaDinheiro.vue?vue&type=style&index=0&id=077706c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077706c2",
  null
  
)

export default component.exports